import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    suratijin_id: '',
    suratijin_name: '',
    suratijin_createdby: '',
    suratijin_createddate: '',
    suratijin_modifyby: '',
    suratijin_modifydate: '',
    rowid: '',
    is_sakit: 0,
    is_ijin: 0,
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const mst07suratijinSlice = createSlice({
  name: 'mst07suratijin',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  resetState,
  setActiveTab,
  clearModuleState,
} = mst07suratijinSlice.actions;

export default mst07suratijinSlice.reducer;
